'use client';

import { useGreenhouseSearch } from '@/hooks/useGreenhouseSearch';
import JobCard from '@/components/JobList/JobCard';

const CareerSearchResults = () => {
  const { filteredJobs, filteredCount, range, totalPages, currentPage } = useGreenhouseSearch();
  const isOutOfBounds = currentPage > totalPages || currentPage < 1;

  if (filteredCount === 0 || isOutOfBounds) {
    return (
      <p className="font-semibold py-20 text-center">Sorry, there are no results that match your selected criteria.</p>
    );
  }

  return (
    <section className="sm:max-w-3xl mx-auto">
      <p className="font-semibold text-center mt-14 sm:mt-18 mb-6">
        Display {range.start} to {range.end} of {filteredCount} matching jobs
      </p>
      <div className="space-y-6">
        {filteredJobs.map(job => (
          <JobCard key={job.id} job={job} />
        ))}
      </div>
    </section>
  );
};

export default CareerSearchResults;
